import React, { useEffect, useState, useRef } from "react";
import { useParams,useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { toast, Toaster } from "react-hot-toast";
import { useUserContext } from "../../contexts/UserContext";
import { QRCodeCanvas } from "qrcode.react";
import printJS from 'print-js';


  const API = "https://backend-ged-immo.onrender.com";
// const API = "http://localhost:4000";

export default function RecuPaiement({ admin }) {
  const navigate = useNavigate();
  const recuRef = useRef();
     const { rentId } = useParams();
    const { user } = useUserContext();
    const token = user?.token;
  
    const [person, setPerson] = useState(null);
    const [rental, setRental] = useState(null);
    const [adminSignature, setAdminSignature] = useState(null);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sendingEmail, setSendingEmail] = useState(false);
    const [adminLogo, setAdminLogo] = useState(null);
   const [whatsappToken, setWhatsappToken] = useState(null);
    const [whatsappPhoneId, setWhatsappNumber] = useState(null);
  const [recu, setRecu] = useState(null);
  const [loading, setLoading] = useState(true);
      const [signatures, setSignatures] = useState([]);
    const [selectedSignature, setSelectedSignature] = useState(null);
  
    const canvasRef = useRef(null);
    const isDrawing = useRef(false);
    const lastPos = useRef({ x: 0, y: 0 });
    const componentRef = useRef(null);


    const formatCurrency = (amount) => Number(amount || 0).toLocaleString("fr-FR") + " FCFA";
    const formatDate = (dateStr) => (dateStr ? new Date(dateStr).toLocaleDateString("fr-FR") : "N/A");
    const formatMonth = (dateStr) =>
      dateStr
        ? new Date(dateStr).toLocaleDateString("fr-FR", { month: "long", year: "numeric" })
        : "N/A";
 


//   const downloadPDF = () => {
//     html2pdf().set({
//       margin: 0.3,
//       filename: `Recu_Paiement_${recu?.numero || "paiement"}.pdf`,
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
//     }).from(recuRef.current).save();
//   };
  
    const handlePrint = useReactToPrint({
      contentRef: componentRef, // ✅ nouveau format
      documentTitle: person
        ? `Reçu - ${person.name} ${person.lastname} du (${formatMonth(rental?.month)})`
        : "Reçu",
  
    });
  
    // 🔹 Récupération complète locataire et son logement
    const fetchPersonData = async (id) => {
      try {
        const res = await fetch(`${API}/detail/locataire/${id}`);
        if (!res.ok) throw new Error("Erreur récupération locataire");
  
        const text = await res.text();
        const data = text ? JSON.parse(text) : { home_id: [], rentals: [] };
        setPerson(data);
        
      } catch (e) {
        console.error("Erreur fetchPersonData:", e);
        toast.error("Impossible de récupérer les données du locataire");
      }
    };
  
    // 🔹 Récupération du paiement + locataire
useEffect(() => {
  const fetchRental = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API}/rents/receipt/${rentId}`);
      if (!res.ok) throw new Error("Impossible de récupérer les données.");
      const data = await res.json();

      setRental(data.rental || data); // ✅ OK
      setPerson(data.person || null);
      setAdminLogo(data?.rental?.adminId?.companyInfo?.logo || null);

      // ⚡ Récupérer aussi les infos complètes du locataire
      if (data.person?._id) {
        await fetchPersonData(data.person._id);
      }

      // 🔹 Ici, il faut mettre recu
      setRecu(data.rental || data); // ✅ <-- Ajouter ça

    } catch (err) {
      console.error(err);
      setError(err.message);
      toast.error("Erreur lors de la récupération du reçu.");
    } finally {
      setLoading(false);
    }
  };
  fetchRental();
}, [rentId]);
  
    // --- Charger les signatures de l’admin depuis le backend ---
    useEffect(() => {
      const fetchAdminSignatures = async () => {
        if (!user?._id) return;
  
        try {
          const res = await fetch(`${API}/${user._id}/signatures`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
  
          if (!res.ok) throw new Error("Impossible de récupérer les signatures admin");
          const data = await res.json();
          const sigArray = Array.isArray(data.signatures) ? data.signatures : [];
  
          setSignatures(sigArray);
          setSelectedSignature(sigArray[0] || null);
        } catch (err) {
          console.error("Erreur fetchAdminSignatures:", err);
          toast.error("Impossible de charger les signatures de l'admin.");
        }
      };
  
      fetchAdminSignatures();
    }, [user, token]);
  
    useEffect(() => {
    const fetchAdminSelectedSignature = async () => {
      try {
        const adminId = rental?.adminId?._id || rental?.adminId;
  
        if (!adminId) return;
  
        const res = await fetch(`${API}/admin/${adminId}/selected-signature`);
        if (!res.ok) return;
  
        const data = await res.json();
        setAdminSignature(data.selectedSignature || null);
  
      } catch (err) {
        console.error("Erreur signature admin :", err);
      }
    };
  
    if (rental) fetchAdminSelectedSignature();
  }, [rental]);




    const platformLogoPath = "/logo4 copie.jpg"; // chemin relatif depuis le dossier public
    
    const handleSendEmail = async () => {
      try {
        if (!person) return toast.error("Données du locataire manquantes.");
        const email = person.email || "";
        if (!email) return toast.error("Email du locataire manquant.");
    
        setSendingEmail(true);
    
        const res = await fetch(`${API}/rents/${rentId}/send-receipt`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
         body: JSON.stringify({
      person_email: email,
      rentId,
      adminName: user?.name || "",
      adminEmail: user?.email || "",
      watermarkLogo: watermarkLogo,       // <— ajouter !
       platformLogo: platformLogoPath,     // <-- variable pour l'image plateforme // <— ajouter !
      signature: selectedSignature || adminSignature
    }),
        });
    
        // 🛑 Gestion permission refusée (403)
        if (res.status === 403) {
          const data = await res.json(); // ← OK car on ne fera PAS res.json() une 2e fois
          toast.error(data?.message || "❌ Permission refusée.");
          return;
        }
    
        // 🛑 Gestion non authentifié (401)
        if (res.status === 401) {
          const data = await res.json();
          toast.error(data?.message || "❌ Vous devez vous reconnecter.");
          return;
        }
    
        // 🛑 Erreurs générales
        if (!res.ok) {
          const errData = await res.json();
          toast.error(errData?.message || "Erreur lors de l'envoi du mail");
          return;
        }
    
        // 🟢 Succès
        const data = await res.json();
        toast.success(data.message || "Email envoyé avec succès !");
      } catch (err) {
        console.error("handleSendEmail error:", err);
        toast.error("Erreur lors de l'envoi du mail");
      } finally {
        setSendingEmail(false);
      }
    };
    

    
// Déterminer le watermark (logo admin ou logo par défaut)
const watermarkLogo =
  adminLogo && adminLogo.startsWith("http")
    ? adminLogo
    : adminLogo
    ? `${API}/${adminLogo}`
    : "/logo4 copie.jpg";

    const home = person?.homeId || {};



  if (loading) return <p style={{ padding: 24 }}>Chargement...</p>;
  if (!recu) return <p style={{ padding: 24 }}>❌ Reçu introuvable</p>;

  return (
    <>
      <Navbar />

        <div className="container__print">
            <button className="btn__print" onClick={handlePrint}>
              <i className="fa-solid fa-print"></i> Imprimer / Télécharger PDF
            </button>
            <button onClick={handleSendEmail} className="btn__email" disabled={sendingEmail}>
              {sendingEmail ? (
                <>
                  <div className="spinner"></div> Envoi en cours...
                </>
              ) : (
                <>
                  <i className="fa-solid fa-envelope"></i> Envoyer le reçu par mail
                </>
              )}
            </button>
             {/* <button onClick={handleSendEmail} className="btn__email" disabled={sendingEmail}>
              {sendingEmail ? (
                <>
                  <div className="spinner"></div> Envoi en cours...
                </>
              ) : (
                <>
                  <i className="fa-solid fa-envelope"></i> Envoyer le reçu par mail
                </>
              )}
            </button> */}
            {/* <button className="btn__whatsapp" onClick={handleSendWhatsapp}>
              <i className="fa-brands fa-whatsapp"></i> Envoyer sur WhatsApp
            </button> */}
             {/* <button className="btn__sms" onClick={handleSendSMS}>
    <i className="fa-solid fa-sms"></i> Envoyer par SMS
  </button> */}
          </div>

      <div className="bulletin-container" ref={recuRef}>
        {/* HEADER */}
        <div className="bulletin-header">
          <div className="company-box">
             <h5>Le propriétaire</h5>
            <p><strong>{rental?.adminId?.fullname || "Néant"}</strong></p>
    <p><strong>{rental?.adminId?.number || "Néant"}</strong></p>
    <p><strong>{rental?.adminId?.email || "Néant"}</strong></p>
    <p><strong>{rental?.adminId?.address || "Néant"}</strong></p>
          </div>

          

          <div className="logo-box">
            {adminLogo ? (
    <img
  src={adminLogo?.startsWith("http") ? adminLogo : `${API}/${adminLogo}`}
  alt="Logo Admin"
  className="admin-logo-header"
/>
  ) : (
    <div className="admin-logo-placeholder">Logo admin indisponible</div>
  )}
          </div>
        </div>

         <div className="company-box">
           <h5>Le locataire</h5>
    <p><strong>Mme/M. {person.name || "N/A"} {person.lastname || ""}</strong></p>
    <p><strong>{person.tel || person.number || "N/A"}</strong></p>
    <p><strong>{person.email || "N/A"}</strong></p>
    <p><strong>{person.address || "N/A"}</strong></p>
          </div>

        {/* TITRE */}
        <div className="title-section">
          <h1>Reçu de paiement</h1>
          <p><strong>Reçu paiement N° {rental.receipt_number || rental._id}</strong></p>
          {/* <p>Date : {recu.date?.split("T")[0]}</p> */}
        </div>

        {/* CLIENT */}
        {/* <table className="salary-table">
          <thead>
            <tr><th colSpan="2">INFORMATIONS LOCATAIRE</th></tr>
          </thead>
          <tbody>
            <tr><td>Nom</td><td>Mme/M. {person.name || "N/A"} {person.lastname || ""}</td></tr>
            <tr><td>Téléphone</td><td>{person.tel || person.number || "N/A"}</td></tr>
            <tr><td>Email</td><td>{person.email || "N/A"}</td></tr>
            <tr><td>Adresse</td><td>{person.address || "N/A"}</td></tr>
          </tbody>
        </table> */}

        {/* BIEN */}
        <table className="salary-table">
          <thead>
            <tr><th colSpan="2">BIEN LOUÉ</th></tr>
          </thead>
          <tbody>
            <tr><td>Type</td><td><strong>{home?.categorie || "Logement"} {home?.NmbrePieces ? `(${home.NmbrePieces} pièces)` : ""}</strong> </td></tr>
            <tr><td>Adresse</td><td><strong>{home?.addressHome || "N/A"}  {home?.quarter && <> , <strong>{home.quarter}</strong></>}</strong></td></tr>
            <tr><td>Loyer</td><td><strong>{Number(home.rent).toLocaleString()} FCFA</strong></td></tr>
             <tr><td>Mois</td><td><strong>{formatMonth(rental?.month)}</strong></td></tr>
            <tr><td>Date de peiement </td><td><strong>{formatDate(rental?.date_of_payment)}</strong></td></tr>
            <tr><td>Mode de peiement </td><td><strong>{rental?.mode || "N/A"}</strong></td></tr>
          </tbody>
        </table>

        {/* PAIEMENT */}
        {/* <table className="salary-table">
          <thead>
            <tr>
                <th>Payé le :</th>
              <th>Mois</th>
              <th>Montant</th>
              <th>Mode de paiement</th>
            
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{formatDate(rental?.date_of_payment)}</td>
              <td>{formatMonth(rental?.month)}</td>
              <td>{Number(home.rent).toLocaleString()} FCFA</td>
              <td>{rental?.mode || "N/A"}</td>
            </tr>
          </tbody>
        </table> */}

        {/* SIGNATURE */}
        <div className="totals">
              <div className="receipt-xxl-footer">
            <p>Fait à Abidjan le <strong>{formatDate(rental?.date_of_payment)}</strong></p>
            <p><strong>Cachet & Signature du Propriétaire</strong></p>
            {/* {adminSignature ? (
  <img
    src={adminSignature.startsWith("http") ? adminSignature : `${API}/${adminSignature}`}
    alt="Signature Admin"
    style={{ maxWidth: 180, marginTop: 10 }}
  />
) : (
  <p>Aucune signature sélectionnée</p>
)} */}

 {/* Image supplémentaire depuis public */}
  <div style={{ marginBottom: 10 }}>
    <img
      src="/sign.png"  // chemin relatif depuis le dossier public
      alt="Image signature / illustration"
      style={{ maxWidth: 200, margin: "0 auto", display: "block" }}
    />
  </div>
          </div>

           <div className="receipt-xxl-qr">
                      
        <QRCodeCanvas value={`${API}/receipt/${rental._id}`} size={50} />
         </div>
        </div>

        <div className="footer-info">
          Reçu de paiement – Document officiel – Merci pour votre confiance
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", margin: 24 }}>
        <button className="btn-secondary" onClick={() => navigate(-1)}>Retour</button>
        {/* <button className="btn-add" onClick={downloadPDF}>📥 Télécharger PDF</button> */}
      </div>

      <Footer />

      {/* ===== CSS ===== */}
      <style>{`
        body {
          background: #f4f6f8;
          font-family: "Inter", system-ui, sans-serif;
        }

        .bulletin-container {
          max-width: 900px;
          margin: 40px auto;
          background: #fff;
          padding: 30px;
          border-radius: 14px;
          box-shadow: 0 10px 30px rgba(0,0,0,.08);
        }

        .bulletin-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
        }

        .company-box {
          border: 2px solid #3b82f6;
          border-radius: 10px;
          padding: 15px;
          width: 48%;
          font-size: 14px;
        }

        .logo-box {
          border: 2px dashed #3b82f6;
          border-radius: 10px;
          padding: 20px;
        }

        .logo-box-img {
          width: 80px;
          height: 80px;
        }

        .logo-box-img img {
          width: 100%;
          height: 100%;
        }

        .title-section {
          text-align: center;
          margin: 20px 0;
        }

        .salary-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 20px;
          font-size: 14px;
        }

        .salary-table th {
          background: #eaf2ff;
          border: 1px solid #c7ddff;
          padding: 10px;
          text-align: left;
        }

        .salary-table td {
          border: 1px solid #e5e7eb;
          padding: 9px;
        }

        .totals {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
        }

        .totals-box {
          width: 48%;
          border: 2px solid #3b82f6;
          border-radius: 10px;
          padding: 15px;
          background: #f8fbff;
        }

        .footer-info {
          text-align: center;
          margin-top: 20px;
          font-size: 12px;
          color: #6b7280;
        }

        .btn-add {
          background: linear-gradient(135deg,#2563eb,#1e3a8a);
          color: white;
          border: none;
          border-radius: 12px;
          padding: 10px 16px;
          cursor: pointer;
          font-weight: 600;
        }

        .btn-secondary {
          background: #eff6ff;
          border: 1px solid #c7ddff;
          border-radius: 12px;
          padding: 10px 16px;
          cursor: pointer;
        }
          .receipt-xxl-qr { text-align: center; }
        .receipt-xxl-qr h5 { color: #4b00cc; margin-bottom: 0.5rem; }
        .receipt-header-logos {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding: 0 1rem;
}

.admin-logo-header,
.platform-logo-header {
  height: 70px;
  width: auto;
  object-fit: contain;
}

.admin-logo-placeholder {
  height: 70px;
  width: 140px;
  font-size: 0.9rem;
  color: #777;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #aaa;
  border-radius: 8px;
}

/* Impression */
@media print {
  .admin-logo-header,
  .platform-logo-header {
    height: 60px !important;
  }
}
      `}</style>
    </>
  );
}